import api from '@/utils/axios'

export default {
  // 修改密码
  postUpdatePassword(body) {
    return api.post('/api/yiyuan/platform/user/login/resetPassword', body)
  },
  // 修改密码发送验证码
  sendVerifyCodeForUpdatePsw(body) {
    return api.post('/api/yiyuan/platform/user/login/resetPassword/sendPhoneVerifyCode', body)
  },
  // 修改手机号
  postUpdateMobile(body) {
    return api.post('/api/yiyuan/platform/user/updateMobile', body)
  },
  // 修改手机号发送验证码
  sendVerifyCodeForUpdateMobile(body) {
    return api.post('/api/yiyuan/platform/user/updateMobile/sendPhoneVerifyCode', body)
  },
  // 查询账户信息
  queryAccountInfo(body) {
    return api.post('/api/yiyuan/platform/corp/queryBaseInfo', body)
  },
  // 查询返佣账户
  queryRebateAccount(body) {
    return api.post('/api/yiyuan//platform/rebateAccount/getInfo', body)
  },
  // 查询有效的返佣账户
  queryRebateAccountValid(body) {
    return api.post('/api/yiyuan//platform/rebateAccount/getValidInfo', body)
  },
  // 返佣账户变更申请
  applyRebateChange(body) {
    return api.post('/api/yiyuan//platform/rebateAccount/applyRebateChange', body)
  },
  // 查询邀请码链接信息
  queryInviteInfo(body) {
    return api.post('/api/yiyuan/platform/corp/queryInviteCode', body)
  },
  // 合同列表信息
  queryContractList(body) {
    return api.post('/api/yiyuan/platform/corp/querySignInfo', body)
  },
  // 易链通推广记录-城市合伙人
  queryPartnerYltPromoteRecord(body) {
    return api.post('/api/yiyuan/platform/promote/corpYltPromotePageList', body)
  },
  // 易链通推广记录-推广大使
  queryEmbassadorYltPromoteRecord(body) {
    return api.post('/api/yiyuan/platform/promote/promoterYltPromotePageList', body)
  },
  // 供票Saas产品推广记录
  querySaasProductRecord(body) {
    return api.post('/api/yiyuan/platform/promote/corpAndPromoterSupplySaaSProductPromotePageList', body)
  },
  // 供票Saas系统维护推广记录-城市合伙人
  querySaasSystemRecord(body) {
    return api.post('/api/yiyuan/platform/promote/corpSupplySaaSSystemPromotePageList', body)
  },
  // 其他产品推广记录
  queryOtherProductRecord(body) {
    return api.post('/api/yiyuan/platform/promote/corpAndPromoterOtherProductPromotePageList', body)
  },
}
